import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { App, Button, Popconfirm } from 'antd'
import { useAccess } from '@/hooks/use-access.ts'
import { useTRPC } from '@/trpc/react.ts'

export function BotDeleteButton({
  bot,
  onDeleted,
  returnToList = false
}: {
  bot: { id: string; name: string; version: number }
  onDeleted: () => Promise<unknown>
  returnToList?: boolean
}) {
  const trpc = useTRPC()
  const access = useAccess()
  const navigate = useNavigate()
  const { message } = App.useApp()
  const [deleted, setDeleted] = useState(false)
  const remove = useMutation(
    trpc.bot.delete.mutationOptions({
      onSuccess: () => {
        setDeleted(true)
        void message.success('机器人已删除')
      },
      onError: (error) => {
        void message.error(error.message)
      }
    })
  )
  if (!access.can('bot.delete')) return null
  return (
    <Popconfirm
      title={`删除“${bot.name}”？`}
      description="永久删除机器人及其凭据、训练授权；已有财务单据或出单记录时请停用。"
      okText="删除"
      okButtonProps={{ danger: true }}
      onConfirm={() => remove.mutateAsync({ id: bot.id, expectedVersion: bot.version })}
      afterOpenChange={(open) => {
        if (!open && deleted) {
          void onDeleted()
          if (returnToList) void navigate({ to: '/system-management/bots', search: {} })
        }
      }}
    >
      <Button danger type={returnToList ? 'default' : 'link'} loading={remove.isPending} disabled={deleted}>
        删除
      </Button>
    </Popconfirm>
  )
}
